import React, { ReactNode } from 'react';
import { useAuth } from './AuthContext';
import LoadingSpinner from '../../shared/components/ui/LoadingSpinner';
import NoProjectAccess from './NoProjectAccess';

/**
 * Renders children only if the authenticated user has at least one Calibraone role.
 * If the user has no role, shows NoProjectAccess (no redirect) to avoid reload loops.
 */
interface RequireProjectAccessProps {
  children: ReactNode;
}

function RequireProjectAccess({ children }: RequireProjectAccessProps) {
  const { user, isLoading, isInitialized, isAuthenticated } = useAuth();

  if (!isInitialized || isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <LoadingSpinner size="lg" />
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return null;
  }

  const hasAnyRole = user?.roles?.length ? user.roles.length > 0 : false;
  if (!hasAnyRole) {
    return <NoProjectAccess />;
  }

  return <>{children}</>;
}

export default RequireProjectAccess;
